import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const Metric = ({ value }) => (
  <div className="metric">
    <div className="metric__fill" style={{ height: `${value * 100}%` }}>
      <div className="metric__label">{(value * 100).toFixed()}%</div>
    </div>
  </div>
);

Metric.propTypes = {
  value: PropTypes.number.isRequired
};

export default Metric;



// WEBPACK FOOTER //
// ./src/components/Metric/index.js